import { jsx as _jsx } from "react/jsx-runtime";
// import components
import ClickAwayListener from "@mui/material/ClickAwayListener";
export const ClickAwayListenerAtomComponent = ({ children, ...props }) => (_jsx(ClickAwayListener, { ...props, children: _jsx("div", { children: children }) }));
export default ClickAwayListenerAtomComponent;
